import { activationClasses } from '../common/consts';

export class PanelCookiesComponent{
  private readonly agreementButton: HTMLButtonElement | null = null;

  constructor(
    private container: HTMLElement | null
  ) {
    if (container) {
      this.agreementButton = container.querySelector('[data-consent-use-cookies-btn]');
    }
  }
  public initialize(): void {
    if (this.agreementButton && this.container) {
      if (!localStorage.getItem('agreement-cookies')) {
        this.container.classList.add(activationClasses.active);
      }
      this.agreementButton.addEventListener('click', () => {
        localStorage.setItem('agreement-cookies', 'true');
        this.container?.classList.remove(activationClasses.active);
      });
    }
  }
}
